var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"my-page"},[_c('div',{staticClass:"my-bg-img"},[_c('img',{staticClass:"gradient-img",attrs:{"src":_vm.$images.my_page_bg_img}})]),_vm._v(" "),_c('div',{staticClass:"layout-header"},[_c('MyTabs',{ref:"myTabs"})],1),_vm._v(" "),_c('div',{staticClass:"layout-content"},[_c('nuxt-child')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }